/**
 * THIS IS A VERSIONED FILE - see readme for more info
 */

import AssetProps from '../20211123/VERSIONED_assetProperties';

export default AssetProps;
